import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogService, DynamicDialogModule, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CustomButtonComponent } from '../custom-components/custom-button/custom-button.component';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { BehaviorSubject, Subject } from 'rxjs';


@Component({
  selector: 'app-custom-modal',
  templateUrl: './custom-modal.component.html',
  styleUrls: ['./custom-modal.component.scss'],
  standalone: true,
  imports: [DynamicDialogModule, ButtonModule, CustomButtonComponent],
  providers: [DialogService]
})
export class CustomModalComponent implements OnInit {
  @Input() idButton: string = '';
  @Input() icon: string = '';
  @Input() label: string = 'Abrir';
  @Input() disabled: boolean = false;
  @Input() closable: boolean = true;
  @Input() focusShow: boolean = true;
  @Input() header: string = 'Emergente';
  @Input() width: string = '90vw';
  @Input() breakpoints: { [key: string]: string } = {
    '1024px': '80vw',
    '768px': '95vw',
    '560px': '100vw'
  };
  @Input() childrenn: any;
  @Input() children: any;
  @Input() inputs$: BehaviorSubject<any>;
  @Input() output$: Subject<any>;
  @Output() selectedItems = new EventEmitter<any>();
  @Output() params = new EventEmitter<any>();

  ref: DynamicDialogRef | undefined;

  constructor(public dialogService: DialogService) { }

  ngOnInit() {
  }

  ngOnDestroy() {
    if (this.ref) this.ref.close();
  }

  public show() {
    this.ref = this.dialogService.open(this.children,
      {
        header: this.header,
        width: this.width,
        modal: true,
        closable: this.closable,
        closeOnEscape: false,
        focusOnShow: this.focusShow,
        contentStyle: { overflow: 'auto' },
        breakpoints: this.breakpoints,
        data: {
          inputs$: this.inputs$,
          output$: this.output$
        }
      });

    this.ref.onClose.subscribe((data: ModalObjectType) => {
      if (!data) return;

      const { selectedItems, params } = data;
      if (selectedItems) {
        const tempSelectedItems = Array.isArray(selectedItems) ? selectedItems : [selectedItems];
        this.selectedItems.emit(tempSelectedItems);
      }

      // eslint-disable-next-line no-extra-boolean-cast
      if (!!params) this.params.emit(params);
    });
  }
}
